export const getUkvData = (state) => state?.data?.getUkvVehicleData;

export const getUkvError = (state) => getUkvData(state)?.error;

export const getUkvHasError = (state) => getUkvError(state) !== null;

export const getUkvVrm = (state) => getUkvData(state)?.vrm;

// Additional Query Variables
export const getUkvAdditionalQueryVariables = () => ({ mileage: null });
